export const styles = {
  tableContainer:
    "relative overflow-x-auto shadow-md rounded-lg bg-white max-w-full max-h-[600px] h-fit",
  noResult:
    "flex flex-col items-center justify-center p-12 font-semibold text-center",
  table: "w-full text-sm text-left text-gray-500",
  tHead: "text-xs text-white uppercase bg-indigo-500 sticky top-0",
  th: "py-4 font-medium text-gray-900 whitespace-normal hover:text-blue-500",
};
